var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 20 20",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 8.499v2.961c0 .275-.246.54-.522.54H12v7.459c0 .275-.24.541-.516.541H8.523C8.248 20 8 19.734 8 19.459V12H.5c-.275 0-.5-.265-.5-.54V8.499A.5.5 0 01.5 8H8V.5c0-.275.248-.5.523-.5h2.961c.276 0 .516.225.516.5V8h7.478c.276 0 .522.224.522.499z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Plus.ebaea9a417c0a1ed42c7c2bacbe1b2ef.svg";